// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginView__wrapper___Y0uAR","mainContainer":"LoginView__mainContainer___XUVu7","fullScreenLoaderContainer":"LoginView__fullScreenLoaderContainer___TAhkB"};